import { Component, OnInit, ViewChild, TemplateRef, Optional, ChangeDetectorRef, LOCALE_ID, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class NoteComponent implements OnInit {

  @ViewChild('footer') footer: TemplateRef<any>;

  record: string;

  submit = new Subject<string>();
  cancel = new Subject<any>();

  placeholder = this.localePipe.transform('component.note.placeholder');

  constructor(
  @Optional() private cdr: ChangeDetectorRef,
  @Inject(LOCALE_ID) private localeId: string,
  @Inject(WF_LANG_RESOURCES) private resources: any,
  @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }


  clickOK() {
    this.submit.next(this.record);
  }

  clickCancel() {
    this.cancel.next();
  }

}
